var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"head_top",attrs:{"id":"head_top"}},[_c('section',{staticClass:"head_detail"},[_c('span',[_vm._v(_vm._s(_vm.headTitle))]),_c('div',{staticClass:"ico_back",on:{"click":function($event){return _vm.$router.go(-1)}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }